module.exports = __webpack_public_path__ + "img/2.88943b43.png";